/**
 * Módulo: Adjustment Modal - Ajuste Manual de Estoque
 * Arquivo: js/pages/suprimentos/estoque/adjustment-modal.js
 * 
 * Permite ajustes manuais (saídas por perdas, quebras, etc.)
 */

window.FazendaRP = window.FazendaRP || {};
window.FazendaRP.Estoque = window.FazendaRP.Estoque || {};
window.FazendaRP.Estoque.AdjustmentModal = {

    /**
     * Renderiza modal de ajuste
     */
    render: function () {
        if (document.getElementById('modal-ajuste-estoque')) return;

        const modal = document.createElement('div');
        modal.id = 'modal-ajuste-estoque';
        modal.style.cssText = "display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 2100; justify-content: center; align-items: center;";
        modal.innerHTML = `
            <div style="background: white; padding: 28px; border-radius: 12px; width: 90%; max-width: 480px; box-shadow: 0 20px 50px rgba(0,0,0,0.3);">
                <h2 style="margin: 0 0 24px 0; color: #111827; font-size: 1.3rem; font-weight: 600;">
                    <i class="fas fa-pen-to-square" style="color: #10b981; margin-right: 8px;"></i>
                    Ajuste Manual de Estoque
                </h2>
                
                <form id="form-ajuste-estoque">
                    <div class="form-group" style="margin-bottom: 16px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 500; color: #374151; font-size: 0.9rem;">
                            Item <span style="color: #ef4444;">*</span>
                        </label>
                        <select id="ajuste-item-select" required style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem; background: #fff;">
                            <option value="">Carregando...</option>
                        </select>
                    </div>
                    
                    <div class="form-group" style="margin-bottom: 16px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 500; color: #374151; font-size: 0.9rem;">
                            Tipo de Ajuste <span style="color: #ef4444;">*</span>
                        </label>
                        <select id="ajuste-tipo" required style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem;">
                            <option value="SAIDA">Saída (Perda/Quebra/Consumo)</option>
                        </select>
                        <small style="color: #6b7280; display: block; margin-top: 6px; font-size: 0.8rem;">
                            <i class="fas fa-info-circle"></i> Entradas devem ser feitas via Nota Fiscal
                        </small>
                    </div>

                    <div class="form-group" style="margin-bottom: 16px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 500; color: #374151; font-size: 0.9rem;">
                            Data da Operação <span style="color: #ef4444;">*</span>
                        </label>
                        <input type="date" id="ajuste-data" required style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem;">
                        <small style="color: #6b7280; display: block; margin-top: 6px; font-size: 0.8rem;">
                            <i class="fas fa-calendar"></i> Data em que a perda/consumo ocorreu
                        </small>
                    </div>
                    
                    <div class="form-group" style="margin-bottom: 16px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 500; color: #374151; font-size: 0.9rem;">
                            Quantidade <span style="color: #ef4444;">*</span>
                        </label>
                        <input type="number" id="ajuste-qtd" step="0.01" min="0.01" required style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem;" placeholder="0,00">
                    </div>
                    
                    <div class="form-group" style="margin-bottom: 24px;">
                        <label style="display: block; margin-bottom: 6px; font-weight: 500; color: #374151; font-size: 0.9rem;">
                            Motivo <span style="color: #ef4444;">*</span>
                        </label>
                        <textarea id="ajuste-obs" rows="3" required style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.9rem; resize: vertical; font-family: inherit;" placeholder="Descreva o motivo do ajuste (ex: quebra, perda, contagem física)"></textarea>
                    </div>
                    
                    <div style="display: flex; justify-content: flex-end; gap: 12px;">
                        <button type="button" onclick="window.FazendaRP.Estoque.AdjustmentModal.close()" style="padding: 10px 20px; border: 1px solid #d1d5db; background: #f3f4f6; color: #374151; border-radius: 6px; cursor: pointer; font-weight: 500; transition: all 0.2s;">
                            Cancelar
                        </button>
                        <button type="submit" id="btn-submit-ajuste" style="padding: 10px 24px; border: none; background: #10b981; color: white; border-radius: 6px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 8px; transition: all 0.2s;">
                            <i class="fas fa-check"></i>
                            Confirmar Ajuste
                        </button>
                    </div>
                </form>
            </div>
        `;
        document.body.appendChild(modal);

        // Click fora fecha
        modal.addEventListener('click', (e) => {
            if (e.target === modal) {
                this.close();
            }
        });

        // Submit handler
        const form = document.getElementById('form-ajuste-estoque');
        form.addEventListener('submit', (e) => this.handleSubmit(e));
    },

    /**
     * Abre modal
     */
    open: async function (preSelectedId = null) {
        this.render();

        const modal = document.getElementById('modal-ajuste-estoque');
        if (!modal) return;

        // Carregar itens
        await this.loadItems(preSelectedId);

        // Data padrão = hoje
        document.getElementById('ajuste-data').value = new Date().toLocaleDateString('en-CA');

        // Limpar form
        document.getElementById('form-ajuste-estoque').reset();

        // Se tiver item pré-selecionado
        if (preSelectedId) {
            document.getElementById('ajuste-item-select').value = preSelectedId;
        }

        modal.style.display = 'flex';
    },

    /**
     * Carrega lista de itens
     */
    loadItems: async function (preSelectedId) {
        const select = document.getElementById('ajuste-item-select');
        if (!select) return;

        try {
            const { data, error } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('id, item_nome, unidade, saldo_atual')
                .order('item_nome');

            if (error) throw error;

            select.innerHTML = data.map(item => {
                const saldo = parseFloat(item.saldo_atual || 0);
                return `<option value="${item.id}">${item.item_nome} (${saldo.toFixed(2)} ${item.unidade})</option>`;
            }).join('');

        } catch (err) {
            select.innerHTML = `<option value="">Erro ao carregar itens</option>`;
            console.error('Erro ao carregar itens:', err);
        }
    },

    /**
     * Processa submit do formulário
     */
    handleSubmit: async function (e) {
        e.preventDefault();

        const btn = document.getElementById('btn-submit-ajuste');
        if (!btn) return;

        const originalHtml = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Salvando...';

        try {
            const itemId = document.getElementById('ajuste-item-select').value;
            const tipo = document.getElementById('ajuste-tipo').value;
            const qtd = parseFloat(document.getElementById('ajuste-qtd').value);
            const obs = document.getElementById('ajuste-obs').value;
            const dataOp = document.getElementById('ajuste-data').value;

            // Buscar item
            const { data: item } = await window.FazendaRP.supabase
                .from('suprimentos_estoque')
                .select('item_nome, unidade')
                .eq('id', itemId)
                .single();

            if (!item) throw new Error('Item não encontrado');

            // Registrar movimentação
            const result = await window.FazendaRP.Estoque.registrarMovimentacao({
                itemNome: item.item_nome,
                tipo: tipo,
                quantidade: qtd,
                origemTipo: 'MANUAL',
                observacao: obs,
                unidade: item.unidade,
                dataOperacao: dataOp
            });

            if (result.success) {
                window.FazendaRP.Toast.show('success', 'Sucesso', 'Ajuste registrado com sucesso!');

                // Reset button BEFORE closing modal
                btn.disabled = false;
                btn.innerHTML = originalHtml;

                this.close();

                // Recarregar tabela
                if (window.FazendaRP.Pages.suprimentos.estoque.loadEstoque) {
                    window.FazendaRP.Pages.suprimentos.estoque.loadEstoque();
                }
            }

        } catch (err) {
            window.FazendaRP.Toast.show('error', 'Erro', 'Falha ao registrar ajuste: ' + err.message);
            btn.disabled = false;
            btn.innerHTML = originalHtml;
        }
    },

    /**
     * Fecha modal
     */
    close: function () {
        const modal = document.getElementById('modal-ajuste-estoque');
        if (modal) modal.style.display = 'none';
    }
};

console.log('✅ Adjustment Modal carregado');
